import React, { useEffect, useState } from "react";
import ButtonControl from "../../../../components/controls/ButtonControl";
import "./../../payout.scss";
import { DialogControl } from "../../../../components/controls/DialogControl";
import { InputField } from "../../../../components/controls/InputField";
import { SelectListControl } from "../../../../components/controls";
import { useStagedUserManager } from "../../../../hooks/useManagers";

export default function AddTeachersMgmt({
  data,
  saving,
  payoutInfo,
  payoutMgr,
  isCompleted = false,
  handleRefresh,
}) {
  const [openDialog, setOpenDialog] = useState(false);
  const [eePassIds, setEEPassIds] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  const userMgr = useStagedUserManager(undefined);

  function handleSelect(type, value) {
    setSelectedUser({ ...value, isManual: true });
  }

  function handleSavePayoutTeacher() {
    const payoutTeacherObj = {
      uid: selectedUser.Id,
      cid: payoutInfo.ClientId,
      did: payoutInfo.DistrictId,
      sid: payoutInfo.SchoolId,
      schoolYear: payoutInfo.SchoolYearIdentifier,
    };

    payoutMgr.SaveIndividualPayoutTeacherItem(payoutTeacherObj).then((r) => {
      if (r.Success) {
        setSelectedUser(undefined);
        setOpenDialog(false);
        handleRefresh();
      }
    });
  }

  useEffect(() => {
    if (eePassIds?.length === 0 && userMgr) {
      const userProfileObj = {
        isActive: true,
        isStaged: false,
        includesStaged: true,
      };

      userMgr
        .runOperation(
          "GetUserProfileList",
          undefined,
          undefined,
          userProfileObj
        )
        .then((r) => {
          if (r.Success) {
            const items = r.Items[0].Data;
            const eePassIdValues = items
              .map((item) => ({ label: item.SystemId, value: item }))
              .sort((a, b) => a?.label?.localeCompare(b?.label));

            setEEPassIds(eePassIdValues);
          } else {
            setEEPassIds([]);
          }
        });
    }
  }, [userMgr, eePassIds]);

  return (
    <div className="add-teachers">
      <div className="teacher-column">
        <h3>Other Teachers</h3>
        <ButtonControl
          loading={saving}
          type={"okay"}
          disabled={isCompleted}
          onClick={() => setOpenDialog(true)}>
          Add Teacher
        </ButtonControl>
      </div>
      <DialogControl
        title="Add Payout Teacher"
        openDialog={openDialog}
        loadingSave={saving}
        okText="Save"
        cancelText={"Cancel"}
        disableOk={
          selectedUser === undefined ||
          data.some((x) => x.UserId === selectedUser.Id)
        }
        onOk={() => handleSavePayoutTeacher()}
        onCancel={() => setOpenDialog(false)}>
        <div className="control-box-wrapper dialog-box-wrapper">
          <div className="dialog-box-row">
            <div className="dialog-box-row">
              <InputField
                id={"eePassId"}
                title={"EE PASS ID"}
                value={selectedUser?.SystemId ?? ""}
                disableError={true}
                placeholder="EE PASS ID"
                type="text">
                <SelectListControl
                  data={eePassIds}
                  hidePleaseSelect={false}
                  onChange={(value) => {
                    handleSelect("eePassId", value);
                  }}
                  searchable
                  virtualized
                  loading={eePassIds?.length === 0}
                />
              </InputField>
              <InputField
                id={"stateId"}
                title={"State ID"}
                value={selectedUser?.StateIdentifier ?? ""}
                disableError={true}
                isDisabled={true}
                placeholder="State ID"
                type="text"
              />
            </div>
            <div className="dialog-box-row">
              <InputField
                id={"email"}
                title={"Email"}
                disableError={true}
                isDisabled={true}
                value={selectedUser?.Email ?? ""}
                placeholder="Email"
                type="text"
              />
            </div>
          </div>
          <div className="dialog-box-row">
            <InputField
              id={"firstName"}
              title={"First Name"}
              disableError={true}
              isDisabled={true}
              value={selectedUser?.FirstName ?? ""}
              placeholder="First Name"
              type="text"
            />
            <InputField
              id={"lastName"}
              title={"Last Name"}
              disableError={true}
              isDisabled={true}
              value={selectedUser?.LastName ?? ""}
              placeholder="Last Name"
              type="text"
            />
          </div>{" "}
          {data.some((x) => x.UserId === selectedUser?.Id) && (
            <div className="red-text">Please select a new user.</div>
          )}
        </div>
      </DialogControl>
    </div>
  );
}
